import CharacterForm from "@src/components/Forms/CharacterForm/CharacterForm";
import Loader from "@src/components/Loader/Loader";
import Page from "@src/layout/Page";
import { Character, Preferences } from "@src/types/global";
import { api } from "@src/utils/axios-instance";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
const CharactersNew = () => {
    const navigate = useNavigate();
    const fetchUserPreferences = async (): Promise<Preferences> => {
        const { data } = (await api.get("/users/settings")) as any;
        return data.data.preferences;
    };
    const preferencesQuery = useQuery<Preferences>({
        queryKey: ["userPref"],
        queryFn: fetchUserPreferences,
        staleTime: 1000,
        refetchOnWindowFocus: true,
    });
    if (preferencesQuery.isPending) {
        return <Loader />;
    }
    return (
        <Page>
            <header>
                <h1>Create a character</h1>
            </header>
            <div>
                <CharacterForm
                    //@ts-ignore
                    character={
                        {
                            is_public:
                                preferencesQuery.data!
                                    .default_character_visibility,
                            is_default: true,
                            is_nsfw: false,
                        } as unknown as Character
                    }
                    measurementUnit={
                        preferencesQuery.data!.measurement_unit || "metric"
                    }
                    submitFormFn={({
                        characterDTO,
                        versionDTO,
                        bodyForm,
                        avatarForm,
                    }) => {
                        // Submit character
                        api.post("characters", {
                            character: {
                                ...characterDTO,
                                character_versions: [versionDTO],
                            },
                        }).then(async (res) => {
                            const data = res.data.data;
                            const characterId = data.id;
                            const defaultVersionId =
                                data.character_versions[0].id;
                            try {
                                await api.patch(
                                    `characters/${characterId}/version/${defaultVersionId}/upload`,
                                    bodyForm,
                                    {
                                        headers: {
                                            "Content-Type":
                                                "multipart/form-data",
                                        },
                                    },
                                );

                                await api.patch(
                                    `characters/${characterId}`,
                                    avatarForm,
                                    {
                                        headers: {
                                            "Content-Type":
                                                "multipart/form-data",
                                        },
                                    },
                                );
                                navigate("/characters/" + characterId);
                            } catch (e: any) {
                                console.trace(e);
                            }
                        });
                        return Promise.resolve();
                    }}
                />
            </div>
        </Page>
    );
};
export default CharactersNew;
